import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
// plugins/lenis.client.ts
import Lenis from 'lenis'

export default defineNuxtPlugin((_nuxtApp) => {
  gsap.registerPlugin(ScrollTrigger)

  const lenis = new Lenis({
    duration: 1.2,
    easing: t => Math.min(1, 1.001 - 2 ** (-10 * t)),
    smoothWheel: true,
  })

  lenis.on('scroll', ScrollTrigger.update)

  // 将 GSAP Ticker 接管 Lenis 的动画循环
  // 这一步至关重要！确保两者在同一帧刷新
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000) // lenis 需要毫秒，gsap 提供秒
  })

  gsap.ticker.lagSmoothing(0)

  // 注入全局
  return {
    provide: {
      lenis,
    },
  }
})
